import { CALL_API } from 'redux-api-middleware';
import { isObject } from 'lodash';
import WebConfig from 'middlewares/WebConfig';

const webApi = () => next => action => {
  if (action && isObject(action[CALL_API])) {
    const apiRequest = action[CALL_API];

    apiRequest.headers = apiRequest.headers || {};

    if(apiRequest.endpoint.includes("RctPhoenix") ){
      apiRequest.endpoint = WebConfig.orthosRoot + apiRequest.endpoint;
    }
    // lets redirect the requests to webApi server
    else{
      apiRequest.endpoint = WebConfig.webApiRoot + apiRequest.endpoint;
    }
  } else if (!action) action = {type: ""};
  return next(action);
};

export default webApi;
